module.exports = "https://cdn-challenge.mathletics.com/app/277/assets/fonts/13a82fa49eeaf93d6b525a3dad74942b.woff2";